var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoodTracking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1183_13419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.72388 6.55804V7.45804",
    stroke: "black",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2761 6.55804V7.45804",
    stroke: "black",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99997 17.3571C14.3485 17.3571 17.3571 14.3486 17.3571 9C17.3571 3.65142 14.3485 0.642853 8.99997 0.642853C3.65139 0.642853 0.642822 3.65142 0.642822 9C0.642822 14.3486 3.65139 17.3571 8.99997 17.3571Z",
    stroke: "black",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.98193 10.8562C5.57974 12.3943 6.96452 13.2313 9.00031 13.2313C11.0361 13.2313 12.4209 12.3943 13.0186 10.8562",
    stroke: "black",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1183_13419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodTracking);
export default __webpack_public_path__ + "static/media/mood_tracking.10b838674b787f609290e1e182fd0a7b.svg";
export { ForwardRef as ReactComponent };